<!-- Ventana Diferido: el motor pinta los campos y la grilla editable del ERP los centros. -->
<lib-dialog>
  <div class="diferido-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">{{ 'ACCOUNTING.DIFERIDO_DIALOG.TITLE' | translate }}</h3>
      <button
        type="button"
        class="close-btn"
        (click)="onCancel()"
        [disabled]="loading()"
        [attr.aria-label]="'ACTIONS.CLOSE' | translate"
      >
        ✕
      </button>
    </div>

    @if (mostrarAlerta()) {
      <div class="alert-container">
        <lib-alert
          [type]="alertaTipo()"
          [title]="alertaTitulo()"
          [message]="alertaMensaje()"
          [autoClose]="false"
          [closeButton]="true"
          (closed)="cerrarAlerta()"
        ></lib-alert>
      </div>
    }

    <div class="dialog-content">
      <form-dynamic [layout]="layout" [form]="diferidoForm" mode="create" [errorFn]="errorDelCampo">
        <ng-template libFormField="centrosDelDiferido">
          <lib-table-compact
            [config]="tablaDeCentros()"
            [data]="filasDeCentros()"
            (changeData)="alCambiarCentro($event)"
            (action)="alAccionarCentro($event)"
            (searchInput)="alBuscarCentro($event)"
          >
            <ng-template libTableCompactCell="codigo" let-row let-index="index">
              <div class="celda-buscador">
                @if (row.codigo) {
                  <span
                    class="celda-buscador__codigo"
                    [matTooltip]="row.nombre"
                    [matTooltipDisabled]="!row.nombre || row.nombre === row.codigo"
                    matTooltipClass="lib-custom-tooltip"
                    >{{ row.codigo }}</span
                  >
                } @else {
                  <span
                    class="celda-buscador__vacio"
                    [matTooltip]="t('ACCOUNTING.DIFERIDO_DIALOG.COLUMN.CODE')"
                    matTooltipClass="lib-custom-tooltip"
                    >{{ t('TREASURY.EXPENSES.MESSAGES.SELECT_COST_CENTER') }}</span
                  >
                }
                @if (!loading()) {
                  <button
                    type="button"
                    class="celda-buscador__lupa"
                    [attr.aria-label]="t('TREASURY.EXPENSES.MESSAGES.SELECT_COST_CENTER')"
                    [matTooltip]="t('TREASURY.EXPENSES.MESSAGES.SELECT_COST_CENTER')"
                    matTooltipClass="lib-custom-tooltip"
                    (click)="buscarEnLaFila(index)"
                  >
                    <lib-icon name="Search" [size]="16" />
                  </button>
                }
              </div>
            </ng-template>
          </lib-table-compact>
        </ng-template>
      </form-dynamic>
    </div>

    <div class="dialog-footer">
      <small class="dialog-nota">{{
        'ACCOUNTING.DIFERIDO_DIALOG.NO_THIRD_PARTY' | translate
      }}</small>
      <div class="actions">
        <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="onCancel()">
          {{ 'COMMON.CANCEL' | translate }}
        </lib-button>
        <lib-button
          variant="primary"
          type="button"
          [disabled]="loading() || !isFormularioValido()"
          (clicked)="onSave()"
        >
          {{ (loading() ? 'COMMON.LOADING' : 'ACTIONS.ACCEPT') | translate }}
        </lib-button>
      </div>
    </div>
  </div>
</lib-dialog>
